import { render } from "./FilesList.vue?vue&type=template&id=037d39cb&scoped=true"
import script from "./FilesList.vue?vue&type=script&lang=js"
export * from "./FilesList.vue?vue&type=script&lang=js"

import "./FilesList.vue?vue&type=style&index=0&id=037d39cb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-037d39cb"
/* hot reload */
if (module.hot) {
  script.__hmrId = "037d39cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('037d39cb', script)) {
    api.reload('037d39cb', script)
  }
  
  module.hot.accept("./FilesList.vue?vue&type=template&id=037d39cb&scoped=true", () => {
    api.rerender('037d39cb', render)
  })

}

script.__file = "src/views/files/modules/FilesList.vue"

export default script